import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeLocale } from './i18n/initLocale';
import './styles/global.css';
import App from './App.tsx';
import { initializeTheme } from './theme/initTheme';

initializeTheme();
initializeLocale();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
